import { model } from "core/util";

import { AmountLegacy } from "../common";

export const BalanceOnContract = model.createModelLegacy("BalanceOnContract", (json) => ({
    insuranceCostSummary: AmountLegacy.fromServer(json.InsuranceCostSummary),
    receivedPayments: AmountLegacy.fromServer(json.ReceivedPayments),
    balanceOnContract: AmountLegacy.fromServer(json.BalanceOnContract),
}));
